export enum RegistryDataColumnTypeEnum {
  text = "text",
  email = "email",
  radio = "radio",
  checkbox = "checkbox",
  descriptive = "descriptive",
  calc = "calc",
  calc_on_read = "calc_on_read",
  calc_on_write = "calc_on_write",
  number = "number",
  dropdown = "dropdown",
  notes = "notes",
  yesno = "yesno",
  file = "file",
  checkbox_option = "checkbox_option",
}

export const COL_OPTIONS_YESNO = [
  { value: "0", label: "yes" },
  { value: "1", label: "no" },
];

export interface IRegistryCheckboxOption {
  label: string;
  value: string;
  lookup_key?: string;
}

export type IRegistryChoiceOptions = {
  [value: string]: IRegistryCheckboxOption;
};

export interface IRegistryDataColumnMapping {
  registry_title: string;
  registry_key: string;
}

export interface IRegistryDataColumn {
  column_key: string;
  fieldversion_id?: string;
  display: string;
  help_text?: string;
  version?: string;
  type: RegistryDataColumnTypeEnum;
  options?: IRegistryChoiceOptions;
  schema_title?: string;
  is_phi?: boolean;
  is_required?: boolean;
  is_passthrough?: boolean;
  is_mapped?: boolean;
  is_never_edit?: boolean;
  is_default_hidden?: boolean;
  is_editable?: boolean;
  mappings?: IRegistryDataColumnMapping[];
  validation?: string;
  calculation?: string;
  // mapping_logic: Optional[List[Dict]] = None
  // code_mappings: Optional[Dict] = None
}
